export default __webpack_public_path__ + "static/media/simple_drapery.a8c1dc69.png";